// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3Ppls","rightAdornment":"Header_rightAdornment__3qQCV"};